import $ from 'jquery';
import apiFetch from "@wordpress/api-fetch";
import {
    getRestRoute,
    hasPaymentMethod
} from '@wc-stripe/utils';
import BaseController from "./BaseController";

class AbstractCheckoutController extends BaseController {

    async createPaymentMethod() {
        try {
            this.disablePlaceOrderButton();
            await this.gateway.createPaymentMethod();
            await this.submit(null);
        } catch (error) {
            this.submitError(error);
        } finally {
            this.enablePlaceOrderButton();
        }
    }

    async createSetupIntent(data = {}) {
        try {
            this.disablePlaceOrderButton();
            const response = await apiFetch({
                method: 'POST',
                url: getRestRoute('setup-intent'),
                data: {
                    payment_method: this.gateway.id,
                    context: this.context.getPage(),
                    payment_method_id: this.gateway.getPaymentMethodId(),
                    ...(this.context.isOrderPay() && {
                        order_id: this.order.getId(),
                        order_key: this.order.getOrderKey()
                    }),
                    ...data
                }
            });
            if (['requires_confirmation', 'requires_payment_method', 'requires_action'].includes(response.status)) {
                const result = await this.handleIntentConfirmation(response);
                this.gateway.setPaymentMethodId(result.setupIntent.payment_method);
            }
            this.gateway.setSetupIntentId(response.id);

            this.submitForm();
        } catch (error) {
            this.gateway.setPaymentMethodId('');
            this.submitError(error);
        } finally {
            this.enablePlaceOrderButton();
        }
    }

    onPaymentMethodSelected(gatewayId) {
        if (this.gateway.id === gatewayId) {
            if (!this.gateway.supports('place_order_button')) {
                if (!this.isPaymentMethodAvailable()) {
                    return this.displayPlaceOrderButton();
                }
                if (this.isSavedPaymentMethodSelected() || this.gateway.hasPaymentMethodId()) {
                    this.hidePaymentElement();
                    this.displayPlaceOrderButton();
                } else {
                    this.displayPaymentElement();
                    this.hidePlaceOrderButton();
                }
            } else {
                this.displayPlaceOrderButton();
            }
        } else {
            // This is not a Stripe gateway so display place order button
            if (gatewayId?.indexOf('stripe_') < 0) {
                this.displayPlaceOrderButton();
            }
            if (!this.gateway.supports('place_order_button')) {
                this.hidePaymentElement();
            }
        }
    }

    onPaymentUnavailable() {
        super.onPaymentUnavailable();
        $(`li.payment_method_${this.gateway.id}`).hide();
    }

    submitError(error) {
        if (this.context.isOrderPay()) {
            this.displayErrorMessage(error, '#order_review');
        } else if (this.context.isCheckout()) {
            this.displayErrorMessage(error, 'form.checkout');
        } else if (this.context.isAddPaymentMethod()) {
            this.displayErrorMessage(error, '#add_payment_method');
        }
    }

    getElementContainer() {
        let el = document.querySelector(this.selector);
        if (!el) {
            $('#place_order').after(`<div id="wc-${this.gateway.id}-checkout-button" class="wc-${this.gateway.id}-checkout-button" style="${this.gateway.getPaymentElementStyles()}"></div>`);
        }
        return super.getElementContainer();
    }

    getForm() {
        if (this.context.isCheckout()) {
            return $('form.checkout');
        }
        return $(this.selector).closest('form');
    }

    triggerPaymentMethodSelected() {
        this.onPaymentMethodSelected($('[name="payment_method"]:checked').val());
    }

    isPaymentGatewaySelected() {
        return $('[name="payment_method"]:checked')?.val() === this.gateway.id;
    }

    isSavedPaymentMethodSelected() {
        const name = `[name="wc-${this.gateway.id}-payment-token"]`;
        return $(name).length > 0 && $(`${name}:checked`).val() !== 'new';
    }

    disablePlaceOrderButton() {
        $('#place_order').prop('disabled', true);
    }

    enablePlaceOrderButton() {
        $('#place_order').prop('disabled', false);
    }

    displayPlaceOrderButton() {
        $('#place_order').removeClass('wc-stripe-hide');
    }

    hidePlaceOrderButton() {
        $('#place_order').addClass('wc-stripe-hide');
    }

}

export default AbstractCheckoutController;